import { IDeleteEntregaObrasClienteUseCase } from "../../../presentation/useCases/delete/delete_entrega_obras_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteEntregaObrasClienteUseCase
 */

export class DeleteEntregaObrasClienteUseCase implements IDeleteEntregaObrasClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObraCliente: number): Promise<void> {
    await this.repository.deleteEntregaObraClienteById(idEntregaObraCliente);

  }
}
